/* eslint-disable no-console */
/* eslint-disable import/prefer-default-export */
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const fetchDamList = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DAM.FETCH_DAM_LIST}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchDamProductList = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DAM.FETCH_DAM_PRODUCT_LIST}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchDamTagList = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DAM.FETCH_DAM_TAGS_LIST}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveDamFiles = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DAM.SAVE_DAM_FILES}`, payload);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getDamRecordById = async (damId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DAM.GET_DAM_BY_ID}/${damId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const updateDamFiles = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DAM.UPDATE_DAM_FILES}/${payload._id}`, payload);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteDamFiles = async (payload) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DAM.DELETE_DAM_FILES}`, {
      data: payload,
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const setArchivedDam = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DAM.ARCHIVE_DAM}`, payload);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const duplicateDamFile = async (data, damId) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DAM.DUPICATE_DAM_FILE}/${damId}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchDamAcrhivedFiles = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DAM.FETCH_ARCHIVED_FILES}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateFileInFolderCollection = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DAM.UPDATE_FOLDER_BY_ID}`, payload);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchDamDeletedFiles = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DAM.FETCH_DELETED_FILES}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateProductDamRecord = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DAM.REFRESH_PRODUCT_DAM}`, payload);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const checkDamNameExist = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DAM.CHECK_ASSET_NAME_EXIST}`, payload);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchAllDAmFolders = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DAM_FOLDER_GROUP.DAM_FOLDER_ALL_LIST}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
